import * as Sentry from '@sentry/browser';
import { Utils } from 'versafleet-core';
// Unsure how to remove the dependency cycle, disabling eslint for this line instead
// eslint-disable-next-line import/no-cycle
import { store } from 'reduxActions';
import NotificationActions from 'reduxActions/notification';

const { PusherHelper, Router } = Utils;

const initialState = {
  profile: null,
  isChecked: false,
};

// this below commented for https://versafleet.atlassian.net/browse/CP-283
// function SetSegmentData(data) {
//   analytics.identify(data.id, data);
// }

function SetSentryPerson(person) {
  Sentry.configureScope((scope) => {
    scope.setUser(person);
  });
}

function initialisePusherEvents() {
  PusherHelper.bindChannel('user', 'new-notification', () => {
    if (Router.getPath().indexOf('notifications') !== -1) {
      store.dispatch(NotificationActions.fetchList());
    } else {
      store.dispatch(NotificationActions.updateNewNotifications(true));
    }
  });

  PusherHelper.bindChannel('user', 'reset-notification-count', () => {
    store.dispatch(NotificationActions.loadNewCount());
  });
}

function profile(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_LOGOUT_SUCCESSFUL':
      return {
        ...initialState,
      };
    case 'REQUEST_CHECK':
      return {
        ...state,
        isChecked: false,
      };
    case 'RECEIVE_CHECK_SUCCESSFUL':
      PusherHelper.subscribe('user', `customer-${action.profile.id}`);
      initialisePusherEvents();
      SetSentryPerson({
        id: `mj_user_${action.profile.id}`,
        account_id: action.profile.myjobs_setting.account_id,
      });
      // this below commented for https://versafleet.atlassian.net/browse/CP-283
      // SetSegmentData({
      //   id: action.profile.id,
      //   name: action.profile.first_name,
      //   account_id: action.profile.account_id,
      //   account_name: action.profile.account_name,
      //   version: global.versionNumber,
      // });
      return {
        ...state,
        profile: action.profile,
        isChecked: true,
      };
    case 'RECEIVE_CHECK_FAILED':
      return {
        ...state,
        profile: null,
        isChecked: true,
      };
    case 'RECEIVE_CHECK_SSO_ENABLED_SUCCESSFUL':
      return {
        ...state,
        sso_enabled: action.is_enabled,
      };
    case 'RECEIVE_SSO_LOGIN_SUCCESSFUL':
      return {
        ...state,
        login_url: action.url,
      };
    case 'RESET_IS_CHECKED':
      return {
        ...state,
        profile: null,
        isChecked: false,
      };
    case 'RECEIVE_VALIDATE_CAPTCHA_FAILED':
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export default profile;
